import { render, staticRenderFns } from "./ShopsOverallBMWM.vue?vue&type=template&id=484da753&scoped=true&"
import script from "./ShopsOverallBMWM.vue?vue&type=script&lang=js&"
export * from "./ShopsOverallBMWM.vue?vue&type=script&lang=js&"
import style0 from "./ShopsOverallBMWM.vue?vue&type=style&index=0&id=484da753&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484da753",
  null
  
)

export default component.exports